/**
 * React Node View für Bilder im Editor.
 *
 * Klick auf ein Bild öffnet es im Doc-Viewer Overlay (Lightbox).
 * Gleiche Systematik wie PaperlessDocLinkView, ViewSnapshotView etc.
 */

import React, { useState, useCallback } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { NodeViewProps } from '@tiptap/core'

export function ImageView({ node, editor }: NodeViewProps) {
  const { src, alt, title } = node.attrs as { src: string; alt: string; title?: string }
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = useCallback(() => {
    if (!src) return
    const fn = (window as any).showDocViewerImage
    if (typeof fn === 'function') {
      fn(src, alt || title || 'Bild')
    }
  }, [src, alt, title])

  return (
    <NodeViewWrapper data-type="image-view" style={{ margin: '0.5em 0' }}>
      <img
        src={src}
        alt={alt || ''}
        title={title || alt || ''}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        draggable={false}
        style={{
          maxWidth: '100%',
          borderRadius: '0.25em',
          display: 'block',
          cursor: 'pointer',
          opacity: isHovered ? 0.85 : 1,
          transition: 'opacity 0.15s ease',
          outline: isHovered ? '2px solid hsl(221 83% 53% / 0.4)' : 'none',
          outlineOffset: '2px',
        }}
      />
    </NodeViewWrapper>
  )
}
